import {
  SR_CONTRACT_START,
  SR_CONTRACT_END,
  SR_CONTRACT_DATA,
  SR_CONTRACT_BY_ID,
  SR_TYPE_CONFIG_DATA,
  SR_TYPE_CONFIG_DATA_ID,
  SR_CONTRACT_RESET,
} from '../../actions/ManufactureChargeback/ActionTypes';

const initialState = {
  loading: false,
  contractData: [],
  contractDataById: {},
  typeConfigData: [],
  typeConfigDataById: {},
};

const ManufacturerChargebackReducer = (state = initialState, action) => {
  switch (action.type) {
    case SR_CONTRACT_DATA:
      return { ...state, contractData: action.data };
    case SR_CONTRACT_BY_ID:
      return { ...state, contractDataById: action.data };
    case SR_TYPE_CONFIG_DATA:
      return { ...state, typeConfigData: action.data };
    case SR_TYPE_CONFIG_DATA_ID:
      return { ...state, typeConfigDataById: action.data };
    case SR_CONTRACT_START:
      return { ...state, loading: true };
    case SR_CONTRACT_END:
      return { ...state, loading: false };
    case SR_CONTRACT_RESET:
      return initialState;
    default:
      return state;
  }
};

export default ManufacturerChargebackReducer;
